// Base de datos de las principales ciudades de España para autocompletado y corrección
// Incluye mapeo automático de Ciudad -> Provincia

export interface CityData {
  name: string;
  province: string;
}

export const SPANISH_PROVINCES = [
  "Álava", "Albacete", "Alicante", "Almería", "Asturias", "Ávila", "Badajoz", "Barcelona", "Burgos", "Cáceres",
  "Cádiz", "Cantabria", "Castellón", "Ciudad Real", "Córdoba", "Cuenca", "Gerona", "Granada", "Guadalajara",
  "Guipúzcoa", "Huelva", "Huesca", "Islas Baleares", "Jaén", "La Coruña", "La Rioja", "Las Palmas", "León",
  "Lérida", "Lugo", "Madrid", "Málaga", "Murcia", "Navarra", "Orense", "Palencia", "Pontevedra", "Salamanca",
  "Santa Cruz de Tenerife", "Segovia", "Sevilla", "Soria", "Tarragona", "Teruel", "Toledo", "Valencia",
  "Valladolid", "Vizcaya", "Zamora", "Zaragoza", "Ceuta", "Melilla"
];

// Lista de las ciudades más pobladas y comunes para sugerencias rápidas
export const MAJOR_CITIES: CityData[] = [
  { name: "Madrid", province: "Madrid" },
  { name: "Barcelona", province: "Barcelona" },
  { name: "Valencia", province: "Valencia" },
  { name: "Sevilla", province: "Sevilla" },
  { name: "Zaragoza", province: "Zaragoza" },
  { name: "Málaga", province: "Málaga" },
  { name: "Murcia", province: "Murcia" },
  { name: "Palma de Mallorca", province: "Islas Baleares" },
  { name: "Las Palmas de Gran Canaria", province: "Las Palmas" },
  { name: "Bilbao", province: "Vizcaya" },
  { name: "Alicante", province: "Alicante" },
  { name: "Córdoba", province: "Córdoba" },
  { name: "Valladolid", province: "Valladolid" },
  { name: "Vigo", province: "Pontevedra" },
  { name: "Gijón", province: "Asturias" },
  { name: "L'Hospitalet de Llobregat", province: "Barcelona" },
  { name: "Vitoria-Gasteiz", province: "Álava" },
  { name: "La Coruña", province: "La Coruña" },
  { name: "Elche", province: "Alicante" },
  { name: "Granada", province: "Granada" },
  { name: "Tarrasa", province: "Barcelona" },
  { name: "Badalona", province: "Barcelona" },
  { name: "Oviedo", province: "Asturias" },
  { name: "Cartagena", province: "Murcia" },
  { name: "Sabadell", province: "Barcelona" },
  { name: "Jerez de la Frontera", province: "Cádiz" },
  { name: "Móstoles", province: "Madrid" },
  { name: "Santa Cruz de Tenerife", province: "Santa Cruz de Tenerife" },
  { name: "Pamplona", province: "Navarra" },
  { name: "Almería", province: "Almería" },
  { name: "Alcalá de Henares", province: "Madrid" },
  { name: "Fuenlabrada", province: "Madrid" },
  { name: "Leganés", province: "Madrid" },
  { name: "San Sebastián", province: "Guipúzcoa" },
  { name: "Getafe", province: "Madrid" },
  { name: "Burgos", province: "Burgos" },
  { name: "Santander", province: "Cantabria" },
  { name: "Albacete", province: "Albacete" },
  { name: "Castellón de la Plana", province: "Castellón" },
  { name: "Alcorcón", province: "Madrid" },
  { name: "San Cristóbal de La Laguna", province: "Santa Cruz de Tenerife" },
  { name: "Logroño", province: "La Rioja" },
  { name: "Badajoz", province: "Badajoz" },
  { name: "Huelva", province: "Huelva" },
  { name: "Salamanca", province: "Salamanca" },
  { name: "Marbella", province: "Málaga" },
  { name: "Lérida", province: "Lérida" },
  { name: "Dos Hermanas", province: "Sevilla" },
  { name: "Tarragona", province: "Tarragona" },
  { name: "Torrejón de Ardoz", province: "Madrid" },
  { name: "Parla", province: "Madrid" },
  { name: "Mataró", province: "Barcelona" },
  { name: "León", province: "León" },
  { name: "Algeciras", province: "Cádiz" },
  { name: "Santa Coloma de Gramenet", province: "Barcelona" },
  { name: "Alcobendas", province: "Madrid" },
  { name: "Cádiz", province: "Cádiz" },
  { name: "Jaén", province: "Jaén" },
  { name: "Reus", province: "Tarragona" },
  { name: "Orense", province: "Orense" },
  { name: "Gerona", province: "Gerona" },
  { name: "Telde", province: "Las Palmas" },
  { name: "Baracaldo", province: "Vizcaya" },
  { name: "Lugo", province: "Lugo" },
  { name: "Santiago de Compostela", province: "La Coruña" },
  { name: "Roquetas de Mar", province: "Almería" },
  { name: "San Fernando", province: "Cádiz" },
  { name: "Cáceres", province: "Cáceres" },
  { name: "Las Rozas de Madrid", province: "Madrid" },
  { name: "San Cugat del Vallés", province: "Barcelona" },
  { name: "Lorca", province: "Murcia" },
  { name: "San Sebastián de los Reyes", province: "Madrid" },
  { name: "Cornellá de Llobregat", province: "Barcelona" },
  { name: "El Puerto de Santa María", province: "Cádiz" },
  { name: "Rivas-Vaciamadrid", province: "Madrid" },
  { name: "Melilla", province: "Melilla" },
  { name: "Pozuelo de Alarcón", province: "Madrid" },
  { name: "Guadalajara", province: "Guadalajara" },
  { name: "Toledo", province: "Toledo" },
  { name: "Ceuta", province: "Ceuta" },
  { name: "Chiclana de la Frontera", province: "Cádiz" },
  { name: "Pontevedra", province: "Pontevedra" },
  { name: "Sant Boi de Llobregat", province: "Barcelona" },
  { name: "Torrevieja", province: "Alicante" },
  { name: "Coslada", province: "Madrid" },
  { name: "Torrente", province: "Valencia" },
  { name: "El Ejido", province: "Almería" },
  { name: "Talavera de la Reina", province: "Toledo" },
  { name: "Fuengirola", province: "Málaga" },
  { name: "Orihuela", province: "Alicante" },
  { name: "Valdemoro", province: "Madrid" },
  { name: "Getxo", province: "Vizcaya" },
  { name: "Mijas", province: "Málaga" },
  { name: "Sanlúcar de Barrameda", province: "Cádiz" },
  { name: "Avilés", province: "Asturias" },
  { name: "Gandía", province: "Valencia" },
  { name: "Benalmádena", province: "Málaga" },
  { name: "Estepona", province: "Málaga" },
  { name: "Majadahonda", province: "Madrid" },
  { name: "Sagunto", province: "Valencia" },
  { name: "Vilanova i la Geltrú", province: "Barcelona" },
  { name: "Castelldefels", province: "Barcelona" },
  { name: "El Prat de Llobregat", province: "Barcelona" },
  { name: "Collado Villalba", province: "Madrid" },
  { name: "Ferrol", province: "La Coruña" },
  { name: "Arrecife", province: "Las Palmas" },
  { name: "La Línea de la Concepción", province: "Cádiz" },
  { name: "Ponferrada", province: "León" },
  { name: "Boadilla del Monte", province: "Madrid" },
  { name: "Irún", province: "Guipúzcoa" },
  { name: "Granollers", province: "Barcelona" },
  { name: "Zamora", province: "Zamora" },
  { name: "Aranjuez", province: "Madrid" },
  { name: "Mérida", province: "Badajoz" },
  { name: "Alcoy", province: "Alicante" },
  { name: "Segovia", province: "Segovia" },
  { name: "Huesca", province: "Huesca" },
  { name: "Ibiza", province: "Islas Baleares" },
  { name: "Cuenca", province: "Cuenca" },
  { name: "Ávila", province: "Ávila" },
  { name: "Ciudad Real", province: "Ciudad Real" },
  { name: "Palencia", province: "Palencia" },
  { name: "Teruel", province: "Teruel" },
  { name: "Soria", province: "Soria" }
];

export function findProvince(cityName: string): string | null {
  const city = MAJOR_CITIES.find(c => c.name.toLowerCase() === cityName.toLowerCase());
  return city ? city.province : null;
}
